// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c0def5{display:grid;grid-gap:.75em}.c0def5>*{margin-top:0}._2a1f58{grid-gap:var(--spacer);grid-template-columns:1fr 1fr}@media screen and (min-width: 94em){._2a1f58{grid-template-columns:1fr 1fr 1fr}}._99b603{grid-template-columns:1fr 1fr}._4ed0e8{grid-template-columns:1fr 1fr 1fr}._2f5d00{grid-template-columns:1fr 1fr 1fr 1fr}.b8a130{grid-column:1/-1}", ""]);
// Exports
exports.locals = {
	"grid": "c0def5",
	"default": "_2a1f58",
	"columns-2": "_99b603",
	"columns2": "_99b603",
	"columns-3": "_4ed0e8",
	"columns3": "_4ed0e8",
	"columns-4": "_2f5d00",
	"columns4": "_2f5d00",
	"width-100": "b8a130",
	"width100": "b8a130"
};
module.exports = exports;
